import React, { useEffect } from 'react';
import axios from 'axios';
import queryString from 'query-string';
const { REACT_APP_MY_LOBBY_BACKEND_URL } = process.env;
const tickLogo = 'https://cdn1.iconfinder.com/data/icons/basic-ui-elements-color-round/3/15-512.png';
export const SignOut = (props) => {
  const parsedQueryString = queryString.parse(window.location.search);
  const reservationId = parseInt(parsedQueryString.reservationId, 10);

  const signout = async () => {
    const response = await axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/rooms_reservations/signOut`, { id: reservationId });
    return response;
  };

  useEffect(() => {
    const data = signout();
    props.hideLoader();
    data.then((d) => {
      console.log('====================================');
      console.log(d);
      console.log('====================================');
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="container max-w-xs mx-auto">
      <div className="full-window columns-1 align-top px-8 pt-6 pd-8 mb-4">
        <div className="grid grid-rows-1 mt-20">
          <p className="text-center text-black text-lg">You are now signed out.</p>
        </div>
        <div className="grid grid-rows-1 mt-40">
          <img className="w-28 h-28 object-center" src={tickLogo} alt="confirm" />
        </div>
      </div>
      <p className="text-center text-black text-xs">Powered by MyLobby.co</p>
    </div>
  );
};
